import React, { useState } from 'react';
import LoginForm from './LoginForm';

const AuthPage = ({ onLogin }) => {
  const [loading, setLoading] = useState(false);

  const handleLogin = async (credentials) => {
    setLoading(true);
    try {
      await onLogin(credentials);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative overflow-hidden flex items-center justify-center p-4"
      style={{ background: 'linear-gradient(145deg, #081120 0%, #0c1a2e 40%, #0E333F 100%)' }}>
      
      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `linear-gradient(rgba(102,194,202,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(102,194,202,0.3) 1px, transparent 1px)`,
          backgroundSize: '60px 60px',
        }}
      />

      {/* Floating teal orbs — bigger and more dynamic */}
      <div className="absolute top-[-120px] right-[-80px] w-[500px] h-[500px] rounded-full opacity-[0.09] animate-pulse-slow"
        style={{ background: 'radial-gradient(circle, #66C2CA 0%, transparent 70%)' }} />
      <div className="absolute bottom-[-100px] left-[-60px] w-[450px] h-[450px] rounded-full opacity-[0.07] animate-pulse-slow-delayed"
        style={{ background: 'radial-gradient(circle, #5EDEE5 0%, transparent 70%)' }} />
      <div className="absolute top-[30%] left-[8%] w-[250px] h-[250px] rounded-full opacity-[0.05] animate-float"
        style={{ background: 'radial-gradient(circle, #9C5EE5 0%, transparent 70%)' }} />
      <div className="absolute top-[15%] right-[20%] w-[180px] h-[180px] rounded-full opacity-[0.04] animate-float-delayed"
        style={{ background: 'radial-gradient(circle, #66C2CA 0%, transparent 70%)' }} />

      {/* Animated wave lines */}
      <svg className="absolute bottom-0 left-0 w-full opacity-[0.06]" viewBox="0 0 1440 320" preserveAspectRatio="none" style={{ height: '40%' }}>
        <path className="animate-wave" fill="none" stroke="#66C2CA" strokeWidth="1.5"
          d="M0,224 C120,180 240,280 360,224 C480,168 600,280 720,224 C840,168 960,280 1080,224 C1200,168 1320,280 1440,224" />
        <path className="animate-wave-delayed" fill="none" stroke="#5EDEE5" strokeWidth="1"
          d="M0,256 C120,212 240,312 360,256 C480,200 600,312 720,256 C840,200 960,312 1080,256 C1200,200 1320,312 1440,256" />
        <path className="animate-wave-slow" fill="none" stroke="#9C5EE5" strokeWidth="0.8"
          d="M0,288 C120,244 240,340 360,288 C480,232 600,340 720,288 C840,232 960,340 1080,288 C1200,232 1320,340 1440,288" />
      </svg>

      {/* Shimmer light sweep */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-[50%] -left-[50%] w-[200%] h-[200%] animate-shimmer"
          style={{
            background: 'conic-gradient(from 0deg at 50% 50%, transparent 0deg, transparent 340deg, rgba(102,194,202,0.04) 350deg, transparent 360deg)',
          }}
        />
      </div>

      {/* Watermark logo */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <img 
          src="https://customer-assets.emergentagent.com/job_broker-borrow-hub/artifacts/96jtqhbt_QuidityDirect%20Logo.png"
          alt=""
          className="w-[500px] h-auto opacity-[0.03] select-none"
          draggable="false"
        />
      </div>

      <div className="w-full max-w-md relative z-10">
        {/* Logo and header */}
        <div className="text-center mb-8">
          <a href="http://quidity.fund" target="_blank" rel="noopener noreferrer" className="inline-block mb-5 overflow-hidden" style={{ height: '80px', width: '320px' }}>
            <img 
              src="https://customer-assets.emergentagent.com/job_e22a09b6-65e1-4ed8-871e-1cefd41bd269/artifacts/5h3c4vac_C44041E2-FC46-43BE-B355-CB56285A03E8.png" 
              alt="Quidity Direct" 
              className="w-full h-full cursor-pointer hover:scale-105 transition-transform"
              style={{ objectFit: 'cover' }}
            />
          </a>
          <h1 className="text-2xl font-bold mb-2"
            style={{ background: 'linear-gradient(90deg, #FFFFFF 0%, #66C2CA 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Quidity Direct Portal
          </h1>
          <p className="text-sm" style={{ color: '#8B9DB6' }}>Your AI powered gateway to streamlined loan processing</p>
        </div>

        <LoginForm
          onLogin={handleLogin}
          loading={loading}
        />

        {/* Footer */}
        <div className="mt-8 text-center">
          <p className="text-xs" style={{ color: '#4A5E75' }}>Quidity Direct &middot; Cashflow Engineering</p>
        </div>
      </div>
    </div>
  );
};

export default AuthPage;
